// extracted by mini-css-extract-plugin
export default {"chosenTerritories":"mZXr4cZVzUxb81HMLpmN"};